/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/procurement-management",
    name: "Dashboard",
    slug: "dashboard",
    icon: "PieChartIcon",
  },
  // User
  {
    header: "Vendor Management",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        url: "/procurement-management/vendor/list/Active",
        name: "All Vendor",
        slug: "calendar-simple-calendar",
        icon: "ListIcon",
        tagColor: "success",
        i18n: "Calendar",
      },
      {
        url: "/procurement-management/vendor/registered",
        name: "Registed / Revised",
        slug: "email",
        icon: "LoaderIcon",
        i18n: "Email",
      },
      {
        url: "/procurement-management/vendor/approval",
        name: "Waiting Approval",
        slug: "email",
        icon: "CheckCircleIcon",
        i18n: "Email",
      },
    ],
  },
  {
    header: "Project Management",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        // url: "/procurement-management/project/new",
        url: "/procurement-management/project/upsert/0",
        name: "Create Project",
        slug: "email",
        icon: "PlusCircleIcon",
        i18n: "Email",
      },
      {
        url: "/procurement-management/project/list",
        name: "All Project",
        slug: "email",
        icon: "ListIcon",
        i18n: "Email",
      },
      {
        url: "/procurement-management/project/approval",
        name: "Waiting Approval",
        slug: "calendar-simple-calendar",
        icon: "CheckCircleIcon",
        tagColor: "success",
        i18n: "Calendar",
      },
      /* {
        url: "/procurement-management/project/list/bidding",
        name: "Project Bidding",
        slug: "calendar-simple-calendar",
        icon: "ShoppingCartIcon",
        tagColor: "success",
        i18n: "Calendar",
      }, */
      {
        url: "/procurement-management/project/history",
        name: "Bidding History",
        slug: "calendar-simple-calendar",
        icon: "CalendarIcon",
        tagColor: "success",
        i18n: "Calendar",
      },
    ],
  },
  // Admin
  {
    header: "Administrator",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      /* {
        url: "/admin/users",
        name: "Manage Users",
        slug: "email",
        icon: "UserIcon",
        i18n: "Email",
      }, */
      {
        url: null,
        name: "Master Data",
        icon: "MenuIcon",
        i18n: "eCommerce",
        submenu: [
          {
            url: "/procurement-management/master/users",
            name: "Users",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
          {
            url: "/procurement-management/master/procuredept",
            name: "Procurement Department",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
          {
            url: "/procurement-management/master/category",
            name: "Category",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
          {
            url: "/procurement-management/master/subcategory",
            name: "Sub Category",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
          {
            url: "/procurement-management/master/commercialtype",
            name: "Commercial Type",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
          {
            url: "/procurement-management/master/commercialprefix",
            name: "Commercial Prefix",
            slug: "ecommerce-checkout",
            i18n: "Checkout",
          },
        ],
      },
    ],
  },
];
